import TncRepository from './TncRepository';

export default TncRepository;
